import {OfferDirection} from '../types/OfferDirection';

const BUYING_ROUTE_PATTERN = /\/buying(\/pdf)?\/?$/;

export const getOfferDirection = (pathname: string): OfferDirection =>
  BUYING_ROUTE_PATTERN.test(pathname) ? 'BUYING' : 'SELLING';
